export enum RoutesEnum {
  play = '/',
  recent = '/recent',
  help = '/help',
  splash = '/splash',
  game = '/game',
  lock = '/lock',
  rules = '/rules',
  login = '/login',
  notFound = '*',
  redirectCallback = '/redirect-callback',
  onboarding = '/onboarding',
  contestRules = '/rules/:id',
  unsubscribe = '/unsubscribe',
  termsAndConditions = '/terms-conditions',
}
